import type { FeatureKey } from 'models/features';
import type { AppState } from 'state/state.model';
import * as fromUserFeatures from 'state/user/feature/feature.selector';

export function getIsTradeEnabled(state: AppState): boolean {
  return fromUserFeatures.isTradeEnabled(state.user);
}

export function getToggleFeatures(state: AppState) {
  return fromUserFeatures.getUserFeatures(state.user);
}

export function isFeatureEnabled(state: AppState, feature: FeatureKey): boolean {
  return fromUserFeatures.isFeatureEnabled(state.user, feature);
}

export function isOrdersBasketEnabled(state: AppState): boolean {
  return fromUserFeatures.isOrdersBasketEnabled(state.user);
}

export function getUserFrontRights(state: AppState) {
  return fromUserFeatures.getFrontRights(state.user);
}
